/**
 * Centralized SEO configuration for all pages
 * This makes it easy to review and update metadata across the site
 */

export interface PageSEO {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
}

export const SEO_CONFIG: Record<string, PageSEO> = {
  home: {
    title: "MovesOffer - Moving Company Auction Platform",
    description: "Find the best moving companies with competitive auction-based pricing. Get quotes from verified movers for your next move across Canada. Save up to 30% on moving costs.",
    keywords: "moving companies, movers, moving quotes, auction, moving services, relocation, canada movers, professional movers, moving bids",
    canonical: "/"
  },
  
  calculator: {
    title: "Moving Cost Calculator - Get Instant Estimates",
    description: "Calculate your moving costs instantly with our free moving calculator. Get accurate estimates based on distance, home size, and services needed for moves across Canada.",
    keywords: "moving calculator, moving cost calculator, moving estimate, moving costs, relocation calculator, moving price estimate",
    canonical: "/calculator"
  },
  
  createOrder: {
    title: "Post Your Move - Get Competitive Quotes",
    description: "Post your moving requirements and receive competitive bids from verified moving companies across Canada. Free, easy, and secure. Get the best moving deal.",
    keywords: "post moving job, get moving quotes, moving auction, create moving order, hire movers",
    canonical: "/create-order"
  },
  
  auctions: {
    title: "Browse Moving Auctions - Find Moving Jobs",
    description: "Browse active moving auctions and bid on jobs across Canada. Find moving opportunities, view job details, and submit competitive bids. Join verified moving companies.",
    keywords: "moving auctions, moving jobs, moving bids, moving company jobs, relocation jobs",
    canonical: "/auctions"
  },
  
  faq: {
    title: "Frequently Asked Questions - MovesOffer",
    description: "Find answers to common questions about MovesOffer's moving company auction platform. Learn how it works, pricing, verification process, and more.",
    keywords: "moving faq, moving questions, movesoffer help, moving platform faq",
    canonical: "/faq"
  },
  
  notFound: {
    title: "404 - Page Not Found",
    description: "The page you're looking for doesn't exist. Explore our moving services and find what you need.",
    keywords: "page not found, 404 error",
    canonical: "/404"
  }
};
